import { Box, Button, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, FormControl, Grid, Icon, InputLabel, MenuItem, ThemeProvider, Typography } from "@mui/material";
import { DataGrid, GridCellParams, GridColDef, GridEventListener } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ButtonStato } from "../../../../../commons/styleds/buttons";
import { GridItemCadastroBtnSalvar } from "../../../../../commons/styleds/grids";
import { IconDrawer } from "../../../../../commons/styleds/icons";
import { SelectStato } from "../../../../../commons/styleds/selects";
import { IIdioma } from "../../../../../commons/types/config";
import { IComanda, ICv } from "../../../../../commons/types/crm";
import InputArquivo from "../../../../../components/InputArquivo/InputArquivo";
import { useIdiomaConfigActions } from "../../../../../states/config/idiomas/idioma.actions";
import { useCvActions } from "../../../../../states/contatos/auxiliares/cvs/cv.actions";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { useRecoilState, useRecoilValue } from "recoil";
import { assessoradoAtom } from "../../../../../states/comandas/AssessoradoState";
import { comandaAtom } from "../../../../../states/comandas/ComandaState";
import { useParams } from "react-router-dom";
import { IParams } from "../../ProgramaAtual";
import { useComandaActions } from "../../../../../states/comandas/comanda.actions";
import { esES, ptBR } from "@mui/material/locale";
import dayjs from "dayjs";
import styled from "styled-components";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from "../../../../../commons/useTranslasion";
import { useDateFormatters } from "../../../../../utils/useDateFormatters";

const empty: ICv = {
  id: 0,
  nome: '',
  idioma: '',
};

const Curriculos = () => {
  const { translate, language } = useTranslation();
  const { formatarData } = useDateFormatters();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  
  const { id } = useParams<IParams>();
  const [comandaState, setComandaState] = useRecoilState(comandaAtom);
  const comandaActions = useComandaActions();
  const cvsActions = useCvActions();
  const [open, setOpen] = useState<boolean>(false);

  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);

  const [idAtualizar, setIdAtualizar] = useState<number | undefined>(undefined);
  const [contatoId, setContatoId] = useState<number | undefined>(undefined);

  const [cvs, setCVs] = useState<ICv[]>([]);
  const [cv, setCV] = useState<ICv>();
  const [selectedCVs, setSelectedCVs] = useState<ICv[] | undefined>(undefined);
  const [idioma, setIdioma] = useState<IIdioma>({} as IIdioma);

  const [editAcao, setEditAcao] = useState<boolean>(false);
  const [acaoEmEdicao, setAcaoEmEdicao] = useState<ICv>(empty);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [acaoDeleteId, setAcaoDeleteId] = useState<number>(0);
  const [nomeArquivo, setNomeArquivo] = useState('');
  const [arquivoUrl, setArquivoUrl] = useState('');

  const [idiomasSelect, setIdiomasSelect] = useState<IIdioma[]>([]);
  const idiomaConfigActions = useIdiomaConfigActions();

  const handleVisualizar = (cv: ICv) => {
    const fileUrl = cv.anexo;
    const fileName = cv.nomeCv?.toLowerCase() || cv.nome?.toLowerCase() || '';

    if (fileName.endsWith('.docx') || fileName.endsWith('.doc')) {
      try {

        const googleDocsUrl = `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;
        window.open(googleDocsUrl, '_blank');
      } catch (error) {
        console.error(translate('erroAoAbrirDocumento'), error);
        toast.error(translate('naoFoiPossivelAbrirDocumento'));

        window.open(fileUrl, '_blank');
      }
    } else {

      window.open(fileUrl, '_blank');
    }
  };

  // const handleDownload = async (obj: ICv) => {
  //   const response = await fetch(obj.anexo);
  //   const blob = await response.blob();

  //   const url = window.URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;

  //   const extension = obj.anexo.split('.').pop()?.split('?')[0] ||
  //     response.headers.get('content-type')?.split('/').pop() || '';

  //   const fileName = `${obj.nomeCv || obj.nome || `documento.${extension}`}`;
  //   link.setAttribute('download', fileName);

  //   document.body.appendChild(link);
  //   link.click();

  //   document.body.removeChild(link);
  //   window.URL.revokeObjectURL(url)
  // }

  const columns: GridColDef[] = [
    {
      field: 'nomeCv',
      headerName: translate('nome'),
      width: 190,
    },
    {
      field: 'idioma',
      headerName: translate('idioma'),
      width: 150,
      renderCell: (params: GridCellParams) => {
        let obj = params.row as ICv;
        return idiomasSelect?.find((f) => f.id === obj.idIdioma)?.nome;
      },
    },
    {
      field: 'dtCadastro',
      headerName: translate('dataDeCadastro'),
      width: 150,
      renderCell: (params: GridCellParams) => formatarData(params.row.dtCadastro ?? params.row.dtAtualizacao),
    },
    {
      field: 'acao',
      headerName: translate('acao'),
      width: 250,
      editable: true,
      renderCell: (params: GridCellParams) => {
        const obj = params.row as ICv;

        return (
          <>
            <Icon
              sx={{ cursor: 'pointer' }}
              onClick={() => handleVisualizar(obj)}
            >
              {' '}
              <VisibilityIcon />{' '}
            </Icon>

            <Icon
              sx={{ marginLeft: '2px', cursor: 'pointer' }}
              onClick={() => handleEditar(cvs.find((f) => f.id === obj.id!)!)}
            >
              <EditIcon />
            </Icon>

            <Icon
              sx={{ marginLeft: '2px', cursor: 'pointer' }}
              onClick={() => handleApagar(obj.id!)}
            >
              {' '}
              <DeleteIcon />{' '}
            </Icon>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    idiomaConfigActions
      .list()
      .then((resp: IIdioma[]) => setIdiomasSelect(resp))
      .catch((err: any) => toast.warn(err));

    const comanda = comandaState.find((f) => f.id === Number(id));
    if (comanda) {
      getCvs(comanda.contato!.id);
      setContatoId(comanda.contato!.id);
    }
    else {
      carregarComanda()
        .then((comanda: IComanda) => getCvs(comanda.contato!.id));
    }
  }, [id]);

  const getCvs = (contatoId: number) => {
    cvsActions
      .list(false, `?contatoId=${contatoId}`)
      .then((resp: ICv[]) => setCVs(resp))
      .catch((err: any) => toast.warn(err))
      .finally(() => setLoading(false));
  }

  const carregarComanda = async () => {
    const comandaGet = await comandaActions.get(Number(id));
    setContatoId(comandaGet.contato!.id);
    return comandaGet;
  }

  const openDrawerCV = (result: any) => {
    setCV(empty);
    setOpen(result);
  };

  const handleEditar = (cv: ICv) => {
    if (!cv) return;

    try {
      const idiomaEncontrado = idiomasSelect.find((f) => f.id === cv.idIdioma);

      setIdAtualizar(cv.id);
      setIdioma(idiomaEncontrado || {} as IIdioma);
      setArquivoUrl(cv.anexo || '');
      setNomeArquivo(cv.nomeCv || '');
      setCV(cv);
      setOpen(true);
    } catch (error) {
      toast.error(translate('erroAoEditarCV'));
      console.error(translate('erroAoEditarCV'), error);
    }
  };

  const handleApagar = (id: any) => {
    cvsActions.delete(id).then(() => {
      const sub = cvs.filter((f) => f.id !== id);
      setCVs(sub);
      toast.success(translate('cvExcluido'));
    });
  };

  const AdicionarNaLista = () => {
    cv!.nome = nomeArquivo;
    cv!.idioma = idioma.nome;
    cv!.idIdioma = idioma.id;
    cv!.nomeCv = nomeArquivo;
    cv!.idContato = contatoId;

    if (idAtualizar && idAtualizar > 0) cv!.id = idAtualizar;

    cvsActions.createFormData(cv!).then(data => {
      cvsActions.list(false, `?contatoId=${contatoId}`).then((resp: ICv[]) => {
        setCVs(resp)
        setIdioma({} as IIdioma);
        setArquivoUrl("");
        setNomeArquivo("");
        openDrawerCV(false);
        toast.success(translate('cvAdicionadoComSucesso'));
      });
    })
    setLoadingSave(false);
  };

  const HandleSetIdioma = (idioma: any) => {
    let id = idioma.target.value;
    let idiomaI = idiomasSelect.find((f) => f.id == id);
    setIdioma(idiomaI!);
  };

  return (
    <>
      <Grid item xs={12} md={12}>
        <Box
          sx={{
            height: '250px',
            width: '100%',
          }}
        >
          <ThemeProvider theme={createTheme({}, locale)}>
            <DataGrid
              getRowId={(row) => row?.id}
              rows={cvs ?? []}
              columns={columns}
              loading={loading}
              sx={{
                backgroundColor: 'white',
                border: '1px solid black',
                borderRadius: '14px',
              }}
            />
          </ThemeProvider>

          <GridItemCadastroBtnSalvar
            item
            xs={11}
            md={11}
            sx={{
              position: 'relative',
              bottom: '34%',
              right: '6%',
              zIndex: '30',
              left: '8%',
            }}
          >
            <ButtonStato
              style={{
                padding: '0px',
                height: '35px',
                minWidth: '35px',
              }}
              onClick={() => openDrawerCV(true)}
              variant='contained'
            >
              +
            </ButtonStato>
          </GridItemCadastroBtnSalvar>
        </Box>
      </Grid>

      <React.Fragment>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: { borderRadius: 8 }
          }}
        >
          <DialogAlert>
            <DialogTitleDailog id="alert-dialog-title">
              {translate('adicionarCV')}
            </DialogTitleDailog>
            <DialogContentDailog>
              <DialogContentText id="alert-dialog-description">
                <Grid container xs={12} sm={12} md={12} sx={{ display: 'flex', marginTop: '-10px', marginBottom: '20px' }}>
                  <Grid xs={12} md={12}>
                    <LabelInput>{translate('idioma')}</LabelInput>
                    <FormControl required fullWidth variant="outlined" sx={{ margin: '20px 0px' }}>
                      <SelectStato
                        value={idioma.id}
                        onChange={HandleSetIdioma}
                        required
                        label=""
                      >
                        {idiomasSelect &&
                          idiomasSelect!.map((idiomaSelect: IIdioma, index: number) => (
                            <MenuItem value={idiomaSelect.id} key={index}>
                              {idiomaSelect.nome}
                            </MenuItem>
                          ))}
                      </SelectStato>
                    </FormControl>
                  </Grid>

                  <Grid container xs={7} sm={7} md={7} sx={{ display: 'flex', paddingRight: '5px' }}>
                    <InputArquivo
                      isEdit={editAcao}
                      objOnEdit={acaoEmEdicao}
                      setObjOnEdit={setAcaoEmEdicao}
                      newObj={cv}
                      setNewObj={setCV}
                      nameFile={nomeArquivo}
                      setNameFile={setNomeArquivo}
                      urlFile={arquivoUrl}
                      setUrlFile={setArquivoUrl}
                    />
                  </Grid>
                </Grid>
              </DialogContentText>
            </DialogContentDailog>
            <DialogActions sx={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
              <ButtonAlertClose variant="outlined" onClick={() => setOpen(false)}>
                {translate('cancelar')}
              </ButtonAlertClose>
              <ButtonAlert variant="contained" onClick={() => AdicionarNaLista()} autoFocus>
                {translate('salvar')}
              </ButtonAlert>

            </DialogActions>
          </DialogAlert>
        </Dialog>
      </React.Fragment>
    </>
  );
}

const ButtonAlertClose = styled(Button)`
width: 170px !important;
height: 44px !important;

font-family: Inter !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 24px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;

color: #414651 !important;
border: 1px solid #D5D7DA !important;
box-shadow: 0px 1px 2px 0px #0A0D120D !important;

border-radius: 8px !important;
margin-right: 10px !important;
`;

const ButtonAlert = styled(Button)`
width: 170px !important;
height: 44px !important;
padding: 10px 18px 10px 18px !important;
gap: 8px !important;
border-radius: 8px !important;
border: 1px 0px 0px 0px !important;
opacity: 0px !important;

background: #118BD7 !important;
border: 1px solid #118BD7 !important;
box-shadow: 0px 1px 2px 0px #0A0D120D !important;

`;

const DialogAlert = styled(Grid)`
width: 480px !important;
padding: 20px !important;
`;

const DialogTitleDailog = styled(DialogTitle)`
//styleName: Text lg/Semibold !important;
font-family: Inter !important;
font-size: 18px !important;
font-weight: 600 !important;
line-height: 28px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;
color: #181D27 !important;
font-size: 22px !important;

`;

const DialogContentDailog = styled(DialogContent)`
//styleName: Text sm/Regular !important;
font-family: Inter !important;
font-size: 14px !important;
font-weight: 400 !important;
line-height: 20px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;
color: #535862 !important;
`;

const GridIcon = styled(Grid)`
width: 60px !important;
height: 60px !important;
gap: 0px !important;
border-radius: 28px !important;
border: 8px 0px 0px 0px !important;
opacity: 0px !important;
Size="lg" !important;
Color="Warning" !important;
Theme="Light circle outline" !important;

display: flex !important;
justify-content: center !important;
align-items: center !important;
`;

const LabelInput = styled(InputLabel)`
//styleName: Text sm/Medium !important;
font-family: Inter !important;
font-size: 14px !important;
font-weight: 500 !important;
line-height: 20px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;
margin-bottom: -15px !important;
margin-top: 20px !important;
`;

export default Curriculos;
